// Base URLs for the online multiplayer backend (RONDA_ONLINE.md Fase 9).
// Also used by VersionCheckManager.jsx to hit GET /app-version.
export const API_BASE_URL = process.env.REACT_APP_ONLINE_API_BASE_URL || 'http://localhost:4000/api/v1';
export const WS_BASE_URL = process.env.REACT_APP_ONLINE_WS_BASE_URL || 'ws://localhost:4000/ws';

// Root of the backend host (same domain that serves /.well-known/assetlinks.json
// and /.well-known/apple-app-site-association, and the /join/:code Universal
// Link / App Link fallback page) — derived from API_BASE_URL by dropping the
// /api/v1 suffix so it stays correct across local/remote-backend envs.
export const WEB_BASE_URL = API_BASE_URL.replace(/\/api\/v1\/?$/, '');
